var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"graph",staticClass:"force-directed-graph"},[_c('svg',{attrs:{"id":"svg","pointer-events":"all","viewBox":("0 0 " + _vm.graphWidth + " " + _vm.graphHeight),"preserveAspectRatio":"xMinYMin meet"}})])}
var staticRenderFns = []

export { render, staticRenderFns }